"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsBaseBreakpoint = void 0;
const react_1 = require("@chakra-ui/react");
function useIsBaseBreakpoint() {
    return (0, react_1.useBreakpointValue)({ base: true, md: false });
}
exports.useIsBaseBreakpoint = useIsBaseBreakpoint;
